(function () {
    class FreeShipping extends HTMLElement {

      constructor() {
        super();
      }
      connectedCallback() {
        this.cartTotal = (this.dataset.cartTotal) ? parseInt(this.dataset.cartTotal) : 0;
        this.baseThreshold = (this.dataset.freeShippingThreshold) ? parseInt(this.dataset.freeShippingThreshold) : 0;
        this.message = (this.dataset.message) ? this.dataset.message : '';
        this.currencySymbol = (this.dataset.currencySymbol) ? this.dataset.currencySymbol : '';
        this.roundAmount = (this.dataset.roundAmount) ? this.dataset.roundAmount : false;

        // Automatically convert the base EUR threshold to the active currency using Shopify's live rate
        this.currencyRate = (window.Shopify && Shopify.currency && Shopify.currency.rate)
          ? parseFloat(Shopify.currency.rate)
          : 1;
        this.freeShippingThreshold = Math.round(this.baseThreshold * this.currencyRate);

        // Recalculate and update the progress bar with the converted threshold
        const progressBar = this.querySelector('progress-bar');
        if (progressBar) {
          const progress = Math.min((this.cartTotal / this.freeShippingThreshold) * 100, 100);
          progressBar.style.setProperty('--progress', progress + '%');
        }

        // Update qualified class based on converted threshold
        if (this.cartTotal >= this.freeShippingThreshold) {
          this.classList.add('free-shipping--hasQualified');
        } else {
          this.classList.remove('free-shipping--hasQualified');
        }

        // If the cart qualifies after currency conversion, switch to the completion message
        if (this.cartTotal >= this.freeShippingThreshold && this.dataset.completeMessage) {
          this.message = this.dataset.completeMessage;
        } else {
          this.amountLeftToSpend = this.getAmountLeft();
        }

        this.setMessage();
        this.addMessage();

        // Update any cart-drawer summary elements that show the threshold amount
        FreeShipping.updateCartSummary(this.currencySymbol, this.freeShippingThreshold, this.cartTotal);
      }
      disconnectedCallback() {
        if (this.querySelector('p')) {
            this.querySelector('p').remove();
        }
      }
      getAmountLeft() {
        let amountLeftToSpend = (this.freeShippingThreshold - this.cartTotal) / 100;
        amountLeftToSpend = Math.round(amountLeftToSpend * 100) / 100;
        amountLeftToSpend = (this.roundAmount) ? Math.ceil(amountLeftToSpend) : amountLeftToSpend;

        return (amountLeftToSpend <= 0) ? 0 : this.currencySymbol + amountLeftToSpend;
      }
      setMessage() {
        this.message = this.message.replace('{{ amount }}', this.amountLeftToSpend);
      }
      addMessage() {
        const node = document.createElement("p");
        node.innerHTML = this.message;
        this.append(node);
      }
      static updateCartSummary(currencySymbol, convertedThresholdCents, cartTotalCents) {
        // Update "For orders over £X" text
        const msgEl = document.querySelector('[data-free-shipping-message]');
        if (msgEl) {
          const baseThreshold = parseInt(msgEl.dataset.baseThreshold) || 0;
          if (baseThreshold > 0) {
            const convertedAmount = Math.ceil(convertedThresholdCents / 100);
            msgEl.textContent = msgEl.dataset.template
              .replace('__SYMBOL__', currencySymbol)
              .replace('__COUNT__', convertedAmount);
          }
        }

        // Update "Free Delivery For Orders Over X" text
        const deliveryMsgEl = document.querySelector('[data-free-delivery-msg]');
        if (deliveryMsgEl) {
          const baseThreshold = parseInt(deliveryMsgEl.dataset.baseThreshold) || 0;
          if (baseThreshold > 0) {
            const convertedAmount = Math.ceil(convertedThresholdCents / 100);
            deliveryMsgEl.textContent = deliveryMsgEl.dataset.template
              .replace('__SYMBOL__', currencySymbol)
              .replace('__COUNT__', convertedAmount);
          }
        }

        // Update "Free" vs "Calculated" shipping status
        const statusEl = document.querySelector('[data-shipping-status]');
        if (statusEl) {
          const isFree = cartTotalCents >= convertedThresholdCents;
          statusEl.textContent = isFree ? statusEl.dataset.freeText : statusEl.dataset.calculatedText;
        }
      }
    }
    window.customElements.define("free-shipping", FreeShipping);
})();
